
import { Component } from "react";
import { Bar, Line } from "react-chartjs-2";
import * as React from "react";
import Axios from "axios";
import { connect } from "react-redux";

const DATE_OPTIONS = {
  month: "short",
  day: "numeric",
};

class LineChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      datacli: {},
      datafrs: {},
    };
  }

  componentDidMount() {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/REGCLIs?dtech&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    ).then((res) => {
      const ipl = res.data;

      let playername = [];
      let runscore = [];

      ipl.forEach((record) => {
        playername.push(
          new Date(record.datecli).toLocaleDateString("fr", DATE_OPTIONS)
        );
        runscore.push(record.sommonreg);
      });

      this.setState({
        datacli: {
          labels: playername,
          datasets: [
            {
              label: "Echéanciers Clients / jour",
              data: runscore,
              backgroundColor: "transparent",
              borderColor: "rgba(255, 99, 132, 1)",
              backgroundColor:"rgb(255, 99, 132, 1)",
             borderWidth: 2,
             
            },
          ],
        },
      });
    });

    Axios.get(
      `https://www.24-crm.tn/webservice/api/REGfrs?dtech&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    ).then((res) => {
      const ipl = res.data;

      let playername = [];
      let runscore = [];

      ipl.forEach((record) => {
        playername.push(
          new Date(record.datecli).toLocaleDateString("fr", DATE_OPTIONS)
        );
        runscore.push(record.sommonreg);
      });

      this.setState({
        datafrs: {
          labels: playername,
          datasets: [
            {
              label: "Echéanciers Fournisseurs / jour",
              data: runscore,
              backgroundColor: "transparent",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 2,
              backgroundColor:"rgb(54, 162, 235, 1)",
             
            },
          ],
        },
      });
    });
  }

  render() {
    const combinedData = {
      labels: this.state.datacli.labels || this.state.datafrs.labels || [],
      datasets: [
        ...(this.state.datacli.datasets || []),
        ...(this.state.datafrs.datasets || []),
      ],
    };

    return (
      <div>
        <div>
           
          <Bar
            data={combinedData}
            options={{ maintainAspectRatio: false }}
            width={"100px"}
            height={"300px"}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ConfigDossier: state.ConfigDossier,
  };
}

export default connect(mapStateToProps, null)(LineChart);



// import React, { Component } from "react";
// import { Button } from "react-bootstrap";
// import "./HomePage.scss";
// import { connect } from "react-redux";
// import { SelectTopclient } from "../../redux/actions/Top5";
// import { SelectTopFrs } from "../../redux/actions/Top5Frs";
// import FTChart from "./FTChart";
// import AchatChart from "./AchatChart";
// import translate from "../../i18n/translate";
// import LineFRS from "./LineFRS";
// import LineEchCLI from"./LineEchCLI";



// class LineChart extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       change: false,
//     };
//   }

//   componentDidMount() {}

//   render() {
//     const { darck } = this.props;
//     return (
//       <div>
//         <div>
//           <Button
//             onClick={() => this.setState({ change: false })}
//             variant="outline-danger"
//           >
//             {translate("Ech Cli")}
//           </Button>{""}
//           &nbsp;
//           <Button
//             onClick={() => this.setState({ change: true })}
//             variant="outline-info"
//           >
//             {translate("Ech Frs")}
//           </Button>
//         </div>
//         <div>
//           {this.state.change ? (
//             <div>
//               <p className={darck ? "p1" : "p1Darck"} style={{ margin: "10px" }}>
//                 {translate("Echéanciers Fournisseurs")}
//               </p>
//               <LineFRS/>
//             </div>
//           ) : (
//             <div>
//               <p className={darck ? "p1" : "p1Darck"} style={{ margin: "10px" }}>
//                 {translate("Echéanciers Clients")}
//               </p>
//               <LineEchCLI/>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   }
// }

// function mapDispatchToProps(dispatch) {
//   return {
//     SelectTopclient: () => dispatch(SelectTopclient()),
//     SelectTopFrs: () => dispatch(SelectTopFrs()),
//   };
// }

// function mapStateToProps(state) {
//   return {
//     tops: state.tops,
//     topfrss: state.topfrss,
//     darck: state.darck.darck,
//   };
// }

// export default connect(mapStateToProps, mapDispatchToProps)(LineChart);







































// import { Component } from "react";
// import { Bar, Line } from "react-chartjs-2";
// import * as React from "react";
// import Axios from "axios";
// import { connect } from "react-redux";

// const DATE_OPTIONS = {
//   month: "short",
//   day: "numeric",
// };

// class LineChart extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       datacli: {},
//       datafrs: {},
//     };
//   }

//   componentDidMount() {
//     Axios.get(
//       `https://www.24-crm.tn/webservice/api/REGCLIs?typtyp&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
//     ).then((res) => {
//       const ipl = res.data;

//       let playername = [];
//       let runscore = [];

//       ipl.forEach((record) => {
//         playername.push(
//           new Date(record.datecli).toLocaleDateString("fr", DATE_OPTIONS)
//         );
//         runscore.push(record.sommonreg);
//       });

//       this.setState({
//         datacli: {
//           labels: playername,
//           datasets: [
//             {
//               label: "Montant REGCLI / jour",
//               data: runscore,
//               backgroundColor: "transparent",
//               borderColor: "rgba(255, 99, 132, 1)",
//               backgroundColor:"rgb(255, 99, 132, 1)",
//              borderWidth: 2,
             
//             },
//           ],
//         },
//       });
//     });

//     Axios.get(
//       `https://www.24-crm.tn/webservice/api/REGfrs?typtyp&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
//     ).then((res) => {
//       const ipl = res.data;

//       let playername = [];
//       let runscore = [];

//       ipl.forEach((record) => {
//         playername.push(
//           new Date(record.datecli).toLocaleDateString("fr", DATE_OPTIONS)
//         );
//         runscore.push(record.sommonreg);
//       });

//       this.setState({
//         datafrs: {
//           labels: playername,
//           datasets: [
//             {
//               label: "Echéanciers Clients",
//               data: runscore,
//               backgroundColor: "transparent",
//               borderColor: "rgba(54, 162, 235, 1)",
//               borderWidth: 2,
//               backgroundColor:"rgb(54, 162, 235, 1)",
             
//             },
//           ],
//         },
//       });
//     });
//   }

//   render() {
//     const combinedData = {
//       labels: this.state.datacli.labels || this.state.datafrs.labels || [],
//       datasets: [
//         ...(this.state.datacli.datasets || []),
//         ...(this.state.datafrs.datasets || []),
//       ],
//     };

//     return (
//       <div>
//         <div>
           
//           <Bar
//             data={combinedData}
//             options={{ maintainAspectRatio: false }}
//             width={"100px"}
//             height={"300px"}
//           />
//         </div>
//       </div>
//     );
//   }
// }

// function mapStateToProps(state) {
//   return {
//     ConfigDossier: state.ConfigDossier,
//   };
// }

// export default connect(mapStateToProps, null)(LineChart);

